export const OVERVIEW_KEYBOARD_KEY = {
  ENTER: 'Enter',
  SPACE: ' ',
} as const;

export const OVERVIEW_HISTORY_PAGE_SIZE = 12;
